import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../App";

export type UserStatus = "pending" | "authorized" | "unauthorized";

export default function useLogin(
    redirectTo: string | null = null
): [UserStatus, string | null] {
    const navigate = useNavigate();
    const [userStatus, setUserStatus] = useState<UserStatus>("pending");
    const appContext = useContext(AppContext);

    useEffect(() => {
        if (appContext) {
            if (appContext.auth) {
                setUserStatus("authorized");
            } else {
                setUserStatus("unauthorized");
                if (redirectTo) {
                    navigate(redirectTo);
                }
            }
        }
    }, [appContext]);

    return [userStatus, appContext ? appContext.auth : null];
}
